module.exports = __webpack_public_path__ + "assets/bz.0944a1fc.svg";